var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChangeAssignee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "55ytmhtqga",
    x1: "-42.375%",
    x2: "148.921%",
    y1: "175.601%",
    y2: "-133.375%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.678%",
    stopColor: "#196BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u0lwqk73eb",
    x1: "172.116%",
    x2: "211.106%",
    y1: "171.427%",
    y2: "-73.763%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.316%",
    stopColor: "#0057A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8c2tzpcqzc",
    x1: "172.116%",
    x2: "211.106%",
    y1: "171.427%",
    y2: "-73.763%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.316%",
    stopColor: "#0057A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v9lu62ytvd",
    x1: "-42.375%",
    x2: "148.921%",
    y1: "175.601%",
    y2: "-133.375%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.678%",
    stopColor: "#196BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DFF7A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1376 -158) translate(1376 158)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#55ytmhtqga)",
    d: "M5.625 3.438c0-.862-.7-1.563-1.563-1.563-.861 0-1.562.7-1.562 1.563C2.5 4.298 3.2 5 4.063 5c.861 0 1.562-.7 1.562-1.563zm-1.563.937c-.516 0-.937-.42-.937-.938 0-.516.42-.937.938-.937.516 0 .937.42.937.938 0 .516-.42.937-.938.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#55ytmhtqga)",
    d: "M4.063 8.125c2.267 0 4.062-1.848 4.062-4.063C8.125 1.822 6.303 0 4.062 0 1.822 0 0 1.822 0 4.063c0 2.213 1.795 4.062 4.063 4.062zm-1.561-1c.032-.832.72-1.5 1.56-1.5.841 0 1.529.668 1.561 1.5-.48.246-1.016.375-1.56.375-.545 0-1.08-.13-1.561-.375zm1.56-6.5C5.958.625 7.5 2.167 7.5 4.063c0 1.05-.486 2.039-1.294 2.686C6.002 5.752 5.119 5 4.062 5c-1.056 0-1.94.752-2.143 1.75C1.111 6.101.625 5.112.625 4.061.625 2.167 2.167.626 4.063.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u0lwqk73eb)",
    d: "M13.5 11.313c0-.862-.7-1.563-1.563-1.563-.861 0-1.562.7-1.562 1.563 0 .861.7 1.562 1.563 1.562.861 0 1.562-.7 1.562-1.563zm-1.563.937c-.516 0-.937-.42-.937-.938 0-.516.42-.937.938-.937.516 0 .937.42.937.938 0 .516-.42.937-.938.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u0lwqk73eb)",
    d: "M11.938 7.875c-2.24 0-4.063 1.822-4.063 4.063C7.875 14.152 9.67 16 11.938 16 14.204 16 16 14.152 16 11.937c0-2.24-1.822-4.062-4.063-4.062zM10.377 15c.032-.832.72-1.5 1.56-1.5.841 0 1.529.668 1.561 1.5-.48.246-1.016.375-1.56.375-.545 0-1.08-.13-1.561-.375zm3.704-.376c-.204-.997-1.087-1.749-2.143-1.749-1.057 0-1.94.752-2.144 1.75-.808-.648-1.294-1.637-1.294-2.688 0-1.895 1.542-3.437 3.438-3.437 1.895 0 3.437 1.542 3.437 3.438 0 1.05-.486 2.039-1.294 2.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8c2tzpcqzc)",
    d: "M7.375 14.563c-1.206 0-2.188-.982-2.188-2.188v-.313H5.5c.118 0 .227-.066.28-.172.052-.106.041-.233-.03-.328l-1.875-2.5c-.059-.078-.152-.124-.25-.124s-.191.046-.25.124l-1.875 2.5c-.071.095-.082.222-.03.328.053.106.162.172.28.172h.313v.313c0 1.55 1.261 2.813 2.812 2.813h2.5c.173 0 .313-.14.313-.313s-.14-.313-.313-.313zm-2.5 0c-1.206 0-2.188-.982-2.188-2.188v-.625c0-.173-.14-.313-.312-.313l1.25-1.666 1.25 1.666c-.173 0-.313.14-.313.313v.625c0 .883.41 1.671 1.047 2.188h-.734z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v9lu62ytvd)",
    d: "M8.625 1.438c1.206 0 2.188.98 2.188 2.187v.313H10.5c-.118 0-.227.066-.28.172-.052.106-.041.233.03.327l1.875 2.5c.059.08.152.125.25.125s.191-.046.25-.125l1.875-2.5c.071-.094.082-.22.03-.327-.053-.106-.162-.173-.28-.173h-.313v-.312c0-.084-.003-.17-.01-.253-.016-.172-.168-.299-.34-.283-.172.015-.299.167-.283.339.006.065.008.131.008.197v.625c0 .173.14.312.313.312l-1.25 1.667-1.25-1.667c.173 0 .313-.14.313-.312v-.625c0-.883-.41-1.671-1.047-2.188h.734c.25 0 .495.042.728.125.163.057.341-.028.399-.191.057-.163-.028-.341-.191-.399-.3-.106-.615-.16-.936-.16h-2.5c-.173 0-.313.14-.313.313s.14.313.313.313z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.094,
    cy: 2.094,
    r: 1,
    fill: "url(#55ytmhtqga)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangeAssignee);
export default __webpack_public_path__ + "static/media/ic-change-assignee.9ebca74840a5c6fb79995d822028511b.svg";
export { ForwardRef as ReactComponent };